import { render, staticRenderFns } from "./Physicalresourcemonitoring.vue?vue&type=template&id=0f0bd805"
import script from "./Physicalresourcemonitoring.vue?vue&type=script&lang=js"
export * from "./Physicalresourcemonitoring.vue?vue&type=script&lang=js"
import style0 from "./Physicalresourcemonitoring.vue?vue&type=style&index=0&id=0f0bd805&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports